import _ from 'lodash';
import angular from 'angular';
import Logger from '../logger';

export const DynamicDataService = (RouteService, Restangular, staticDataService) => {
    const getFilteredValues = function (body) {
        return Restangular.all('search')
            .all('getSearchFilterValues')
            .post(body)
            .catch(error => Logger.error(error));
    };

    const getFilteredSemiValues = function (body) {
        return Restangular.all('metadata')
            .all('semiDynamicLookups')
            .post(body)
            .catch(error => Logger.error(error));
    };

    const getNationwideLocations = function (uid) {
        return Restangular.all('metadata')
            .all('nationwideLocations')
            .post({ uid })
            .catch(error => Logger.error(error));
    };

    const addSubCriteriaData = function ({ criteria }) {
        if (criteria.subCriteria !== null) {
            staticDataService.getStaticData(criteria.subCriteria.lookupData, (data) => {
                if (data) {
                    criteria.selected = (criteria.selected || []).map((item) => {
                        const additionalId = _.get(item, 'additional.uid');
                        const currentAdditionalValue = _.get(item, 'additional.value');
                        const additionalValue = data.find(({ id }) => id === additionalId);

                        if (additionalValue && !currentAdditionalValue) {
                            return {
                                ...item,
                                additional: {
                                    ...item.additional,
                                    ...additionalValue,
                                },
                            };
                        }

                        return item;
                    });
                }
            });
        }
    };

    return {
        addSubCriteriaData,
        getFilteredValues,
        getFilteredSemiValues,
        getNationwideLocations,
    };
};

angular.module('TALENYA-FE')
    .factory('dynamicDataService', DynamicDataService);
